// Decorative gold sacred-geometry SVGs used as watermarks and flourishes.

export function ChokuRei({ className = "", strokeWidth = 1.5 }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round">
      <path d="M50 8 L50 62" />
      <path d="M30 20 L50 20" />
      <path d="M50 62 C50 82 22 82 22 60 C22 44 40 44 40 56" />
    </svg>
  );
}

export function FlowerOfLife({ className = "" }) {
  const r = 14;
  const cx = 50, cy = 50;
  const centers = [[cx, cy]];
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 3) * i;
    centers.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]);
  }
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth="0.7">
      {centers.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={r} />
      ))}
      <circle cx={cx} cy={cy} r={r * 2} />
    </svg>
  );
}

export function Enso({ className = "" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
      <path d="M78 30 A38 38 0 1 0 82 62" />
    </svg>
  );
}
